import { render, staticRenderFns } from "./SendToVendor.vue?vue&type=template&id=3f8372f5&scoped=true&"
import script from "./SendToVendor.vue?vue&type=script&lang=js&"
export * from "./SendToVendor.vue?vue&type=script&lang=js&"
import style0 from "./SendToVendor.vue?vue&type=style&index=0&id=3f8372f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8372f5",
  null
  
)

export default component.exports